import React from 'react';
const CartDrawer: React.FC = () => null;
export { CartDrawer }; 